const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class DesktopMenuCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    document.addEventListener('drawerOpen', e => {
      if (e.detail.key === 'desktop' && this.carousel) {
        this.carousel.destroy()
        this.carousel = this.setupCarousel()
      }
    })

    window.addEventListener('resize', () => {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = this.setupCarousel()
      }
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 3.25,
          spacing: 20,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('desktop-menu-carousel')) {
  customElements.define('desktop-menu-carousel', DesktopMenuCarousel)
}
